<div class="Customers customer-company ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'common.store_title' | translate }}</h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" routerLink="/store-common" label="{{ 'common.back' | translate }}"></button>
    <button pButton (click)="save()" type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}"></button>
  </div>

  <div class="clearfix"></div>
  <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>
  <div class="clearfix"></div>

  <div class="store-container card ui-g-nopad" style="display: block; width: 100%;">
    <app-kv-store-common-basic
      [validationForm]="validationForm"
      [hidden]="activeIndex !== 0"
      [editMode]="editMode"
      [storeId]="storeId"
    ></app-kv-store-common-basic>

    <app-kv-store-common-link
      [hidden]="activeIndex !== 1"
      [editMode]="editMode"
      [storeId]="storeId"
    ></app-kv-store-common-link>

    <app-store-common-services
      [hidden]="activeIndex !== 2"
      [editMode]="editMode"
      [storeId]="storeId"
    ></app-store-common-services>

    <app-store-common-calendars
      [hidden]="activeIndex !== 3"
      [editMode]="editMode"
      [storeId]="storeId"
    ></app-store-common-calendars>

    <app-store-common-classification
      [hidden]="activeIndex !== 4"
      [editMode]="editMode"
      [storeId]="storeId"
    ></app-store-common-classification>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-form.component.html